import React from 'react'
import { array, bool, func, number } from 'prop-types';

import { toDateString } from '@ajaibid/utils';
import noop from '@helpers/noop';

import { FormatRupiah } from 'Component/NumberFormat';
import { PopUpCenterV2 } from 'Component/PopUp';
import Tag from 'Component/Tag';
import OnGoingRdn from 'Component/OnGoingRdn'
import { Button } from '@ajaibid/components';

import {
  styAmountContent,
  styAmountEligible,
  styAmountRight,
  styDateTitle,
  styDateContent,
  styInfoContent,
  styTitleCenter,
  styTagTimeline,
  styTagWrapper,
  styTimeline,
  styTextContent,
  styTimelineLeft,
  styVerticalLine
} from './style'
import useEventTracker from '../tracker';

const PopupDetail = ({ 
  balance,
  cashLog,
  cashRaw,
  onGoingAmount,
  isShowRdnNegative,
  isShowPopup, 
  setIsShowPopup 
}) =>  {
  const { eventClickRdnProcessedClose } = useEventTracker()
  return (
    <PopUpCenterV2
      show={isShowPopup}
      width="540px"
      closeButton={false}
      onHide={() => setIsShowPopup(false)}
    >
      <div className={styTitleCenter}>
        <span>Saldo Bisa Ditarik</span>
        <span className={styAmountEligible}>
          <FormatRupiah value={balance}/>
        </span>
        {
          (cashRaw < 0 && isShowRdnNegative) && (
            <span>
              (<FormatRupiah value={cashRaw}/>)
            </span>
          )
        }
        <OnGoingRdn 
          isCenter
          onGoingAmount={onGoingAmount}
        />
      </div>
      <div className={styTimeline}>
        <div>
          <span className={styDateTitle}>
            Tanggal
          </span>
          <div className={styTimelineLeft}>
            {
              cashLog?.map((cash, i) => (   
                <div key={i}>
                  <div className={styTagTimeline}>
                    <Tag
                      id={i}
                      label={`T+${i}`}
                      type="default"
                      className={styTagWrapper}
                    />
                      <div className={styDateContent}>
                        {toDateString(cash.date)}
                      </div>
                    </div>
                  <div className={styVerticalLine}/>
                </div>
              ))
            }
          </div>
        </div>
        <div>
          <span>
            Saldo Selesai Diproses 
          </span>
          <div className={styAmountRight}>
            {
              cashLog?.map((amount, id) => (
                <span key={id} className={styAmountContent}>
                  <FormatRupiah value={amount.pending_positive_settlement} />
                </span>
              )) 
            }
          </div>
        </div>
      </div>
      <div className={styInfoContent}>
        <span className={styTextContent}>
          <b> Saldo Diproses </b>Saldo Diproses adalah hasil jual saham yang sedang diproses untuk masuk ke Saldo RDN kamu. Proses ini memakan waktu 2 hari kerja setelah transaksi.
          <b> Saldo diperbarui pukul 10.00 - 13.30 WIB.</b>
        </span> 
        <span className={styTextContent}>
          <b>Saldo Bisa Ditarik </b> adalah saldo yang bisa kamu cairkan ke rekening kamu.</span>
        <span className={styTextContent}>
          <b>Saldo Minus</b> muncul ketika kamu bertransaksi beli melebihi jumlah Saldo Bisa Ditarik. Saldo minus akan hilang ketika periode Saldo Diproses selesai atau kamu melakukan deposit ke RDN.
        </span>
      </div>
      <Button
        type="button"
        variant="primary"
        onClick={() => {
          setIsShowPopup(false)
          eventClickRdnProcessedClose();
        }}
        fluid
        style={{ marginTop: '32px' }}
      >
        Mengerti
      </Button>
    </PopUpCenterV2>
  )
}


PopupDetail.propTypes = {
  balance: number,
  cashLog: array,
  cashRaw: number,
  onGoingAmount: number,
  isShowPopup: bool, 
  isShowRdnNegative: bool, 
  setIsShowPopup: func, 
};

PopupDetail.defaultProps = {
  balance: 0,
  cashLog: [],
  cashRaw: 0,
  onGoingAmount: 0,
  isShowPopup: true, 
  isShowRdnNegative: false, 
  setIsShowPopup: noop, 
};

export default PopupDetail
